module.exports = __webpack_public_path__ + "img/2020-3.481bec1f.jpg";